<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row class="filter">
      <el-col style="border: 1px solid #ddd">
        <div style="padding: 10px 25px">
          <el-form
            ref="form"
            :inline="true"
            class="demo-ruleForm"
            :model="form"
          >
            <el-form-item label="向左转">
              <el-select
                v-model="form.cpid"
                placeholder="请选择快递公司"
                multiple
                @change="setting"
              >
                <el-option
                  v-for="(shipping, key) in shipping_company"
                  :key="key"
                  :label="shipping"
                  :value="key.toString()"
                ></el-option>
              </el-select>
              (其他快递默认向右)
            </el-form-item>
            <hr />
            <el-form-item label="快递限重配置">
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
            <br />
            <el-form-item
              v-for="weight_limit in shipping_company_weight_limit"
              :key="weight_limit.shipping_company"
              :label="weight_limit.shipping_company"
            >
              <el-input
                v-model="weight_limit.weight_limit"
                style="width: 80px"
              ></el-input>
              KG
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import HeaderTabs from "./components/HeaderTabs";
export default {
  name: "Weighturnsetting",
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },
  data() {
    return {
      shipping_company: null,
      shipping_company_weight_limit: {},
      form: {
        cpid: [],
      },
      url: "/erp/WavePicking/weighTurnSetting",
      loading: false,
    };
  },
  mounted() {},
  methods: {
    fetchData() {
      this.$http.get(this.url, {}).then(res => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.shipping_company = res.data.data.shipping_company;
          this.form.cpid = res.data.data.setting;
        }
      });

      //获取限重配置
      this.$http.get("/erp/WavePicking/indexWeightLimit", {}).then(res => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.shipping_company_weight_limit = res.data.data;
          // this.form.cpid = res.data.data.setting
        }
      });
    },
    setting() {
      this.$http.post(this.url, this.form).then(res => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
    onSubmit() {
      this.loading = true;
      let data = {};
      for (let key in this.shipping_company_weight_limit) {
        data[key] = this.shipping_company_weight_limit[key].weight_limit;
      }

      this.$http
        .put("/erp/WavePicking/updateWeightLimit", {
          weight_limit: data,
        })
        .then(res => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success("操作成功");
          }
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/wavepicking/WeighTurnSetting.vue